// extracted by mini-css-extract-plugin
export default {"rating":"tJ-z","numberOfStars":"uJ-z","count":"vJ-z","barGraphSpacing":"wJ-z","barGraph":"xJ-z"};